import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

// 🔐 Final origin rule
// const isAllowedOrigin = (origin) => {
//   return (
//     origin === window.location.origin ||
//     origin === "https://www.winfertilitypatient.com"
//   );
// };

const PaymentIframe = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const paymentLink = location.state?.paymentLink;
    const updatedProviderData = location.state?.updatedProviderData;
    const otherData = location.state?.otherData;

    useEffect(() => {
        const handleMessage = (event) => {
            console.log("📩 postMessage RECEIVED");
            console.log("Origin:", event.origin);
            console.log("Data:", event.data);

            // 🔐 Origin validation
            if (
                event.origin !== window.location.origin 
                &&
                event.origin !== "https://www.winfertilitypatient.com"
            ) {
                console.warn("❌ Blocked postMessage from:", event.origin);
                return;
            }

            const { type, message } = event.data || {};

            if (!type) {
                console.warn("⚠️ postMessage received without type");
                return;
            }

            // Normalize
            const normalizedType = type.toUpperCase();

            if (normalizedType === "IFRAME_SUBMIT_ERROR") {
                console.error("Iframe payment failed:", message);
                navigate("/payment", {
                    replace: true,
                    state: {
                        paymentStatus: "failed",
                        updatedProviderData,
                        otherData
                    }
                });
                return;
            }

            if (normalizedType === "IFRAME_SUBMIT_SUCCESS") {
                console.log("✅ Iframe payment success");
                navigate("/payment", {
                    replace: true,
                    state: {
                        paymentStatus: "success",
                        updatedProviderData,
                        otherData
                    }
                });
            }
        };

        window.addEventListener("message", handleMessage);
        return () => window.removeEventListener("message", handleMessage);
    }, [navigate, updatedProviderData, otherData]);

    if (!paymentLink) {
        return <h2>No payment link provided</h2>;
    }

    return (
        <iframe
            src={paymentLink}
            title="Payment"
            style={{ width: "100vw", height: "100vh", border: "none" }}
        />
    );
};

export default PaymentIframe;
